var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "box has-text-centered" },
            [_c("loading-spin")],
            1
          )
        : _vm._l(_vm.certs, function (cert, index) {
            return _c("div", { key: index, staticClass: "box mb-4" }, [
              cert.estado === "pre-pendiente"
                ? _c(
                    "section",
                    {
                      staticClass:
                        "is-flex is-flex-direction-row is-align-items-center is-justify-content-center pb-4",
                    },
                    [
                      _c("b-message", { attrs: { type: "is-danger" } }, [
                        _vm._v(
                          "\n          Este certificado se encuentra en un estado incompleto. Por favor, comunicarse con un administrador de Lyris IT para resolver el problema.\n      "
                        ),
                      ]),
                    ],
                    1
                  )
                : _c("section", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "is-flex is-flex-direction-row is-align-items-center mb-1",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "is-flex is-flex-direction-column is-flex-grow-1 is-italic",
                          },
                          [
                            cert.estado === "pendiente"
                              ? _c("div", { staticClass: "is-6 mb-2" }, [
                                  _c(
                                    "h6",
                                    [
                                      _vm._v("Solicitud "),
                                      cert.usuario.cantidad_certificados === 1
                                        ? _c(
                                            "b-tooltip",
                                            {
                                              attrs: {
                                                label:
                                                  "Esta es la primera solicitud del suscriptor",
                                                type: "is-warning",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-exclamation-circle fa-lg has-text-warning",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "is-flex is-flex-direction-row" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "is-size-6 is-400" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "is-size-6 is-500" },
                                      [_vm._v("Usuario:")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(cert.usuario.nombre) +
                                        " " +
                                        _vm._s(cert.usuario.apellido) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" - \n            "),
                                _c(
                                  "span",
                                  { staticClass: "is-size-6 is-400" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "is-size-6 is-500" },
                                      [_vm._v("CUIL:")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(cert.usuario.cuil) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.hasRole([
                              _vm.constants.STRINGS.ROLES.LYRIS.ID,
                              _vm.constants.STRINGS.ROLES.LYRIS_OR.ID,
                            ])
                              ? _c(
                                  "span",
                                  { staticClass: "is-size-6 is-500 disabled" },
                                  [
                                    _vm._v(
                                      "\n            Organización: " +
                                        _vm._s(cert.organizacion.razon_social) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        cert.estado === "pendiente"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-warning is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Pendiente")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "preaprobado"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-info is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Preaprobado")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: "El certificado está por vencerse",
                              type: "is-warning is-light",
                              active: cert.por_vencer,
                            },
                          },
                          [
                            cert.estado === "vigente"
                              ? _c(
                                  "b-tag",
                                  {
                                    staticClass: "is-500",
                                    attrs: {
                                      rounded: "",
                                      type: cert.por_vencer
                                        ? "is-warning"
                                        : "is-success is-light",
                                      size: "is-medium",
                                    },
                                  },
                                  [
                                    _vm._v("Vigente "),
                                    cert.por_vencer
                                      ? _c("b-icon", {
                                          attrs: {
                                            pack: "fas",
                                            icon: "exclamation-triangle",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        cert.estado === "revocado"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-danger is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Revocado")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "rechazado"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-danger is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Rechazado")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "vencido"
                          ? _c(
                              "b-tag",
                              {
                                staticClass: "is-500",
                                attrs: {
                                  rounded: "",
                                  type: "is-light",
                                  size: "is-medium",
                                },
                              },
                              [_vm._v("Vencido")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    cert.estado === "vigente" ||
                    cert.estado === "pendiente" ||
                    cert.estado === "preaprobado"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "is-flex is-flex-direction-row is-align-items-center py-2",
                          },
                          [
                            cert.estado === "pendiente" &&
                            _vm.hasRole([
                              _vm.constants.STRINGS.ROLES
                                .ADMINISTRADOR_DE_CERTIFICADOS.ID,
                              _vm.constants.STRINGS.ROLES.LYRIS.ID,
                            ])
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "button is-info is-outlined mr-4",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showPreapprovedDialog(cert)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-signature",
                                    }),
                                    _vm._v(
                                      "  Firmó el acuerdo de suscriptores\n        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            cert.estado === "preaprobado" && _vm.enabledOr
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "button is-success is-outlined mr-4",
                                    attrs: {
                                      to: {
                                        name: "certificadoAprobacion",
                                        params: { idCert: cert.id },
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-check" }),
                                    _vm._v("  Aprobar\n        "),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.canBeRejected(cert)
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass: "button is-danger is-outlined",
                                    attrs: {
                                      to: {
                                        name: "certificadoRechazo",
                                        params: { idCert: cert.id },
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-times" }),
                                    _vm._v(
                                      "  " +
                                        _vm._s(
                                          _vm.getTextForRejectAction(
                                            cert.estado
                                          )
                                        ) +
                                        "\n        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            cert.estado === "vigente" && _vm.enabledOr
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "button is-danger is-outlined mr-4",
                                    attrs: {
                                      to: {
                                        name: "certificadosRevocacion",
                                        params: { idCert: cert.id },
                                        query: { fromOR: true },
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-times" }),
                                    _vm._v("  Revocar\n        "),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            cert.estado === "vigente" &&
                            _vm.hasRole([
                              _vm.constants.STRINGS.ROLES.OFICIAL_DE_REGISTRO
                                .ID,
                            ])
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "is-primary is-outlined mr-4",
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadActaAlta(
                                          cert.documento_alta_id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-download" }),
                                    _vm._v(
                                      "  Descargar acta de alta\n        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            cert.estado === "vigente" &&
                            _vm.hasRole([
                              _vm.constants.STRINGS.ROLES
                                .ADMINISTRADOR_DE_CERTIFICADOS.ID,
                            ])
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "is-link is-outlined mr-4",
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadCurrentCertificate(
                                          cert.usuario
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-cloud-download-alt",
                                    }),
                                    _vm._v("  Descargar certificado\n        "),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "is-flex is-flex-direction-column" },
                      [
                        cert.estado === "rechazado" && cert.comentario
                          ? _c(
                              "span",
                              { staticClass: "is-size-6 is-400 mb-1" },
                              [
                                _c("span", { staticClass: "is-500" }, [
                                  _vm._v("Motivo de rechazo:"),
                                ]),
                                _vm._v(
                                  " " + _vm._s(cert.comentario) + "\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "pendiente" ||
                        cert.estado === "rechazado"
                          ? _c("span", { staticClass: "mt-1" }, [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Fecha de solicitud:"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.dateFormat(cert.created_at)) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado !== "pendiente" &&
                        cert.estado !== "rechazado"
                          ? _c("span", [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Fecha de emisión:"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.dateFormat(cert.fecha_emision)) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado !== "pendiente" &&
                        cert.estado !== "rechazado"
                          ? _c("span", { staticClass: "mt-1" }, [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Fecha de vencimiento:"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.dateFormat(cert.fecha_vencimiento)
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "revocado"
                          ? _c("span", { staticClass: "mt-1" }, [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Fecha de revocación:"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.dateFormat(cert.fecha_revocacion)
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "revocado"
                          ? _c("span", { staticClass: "mt-1" }, [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Motivo de revocación:"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.reasonString(
                                      cert.razon_revocacion.toLowerCase()
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado === "revocado" && cert.comentario
                          ? _c("span", { staticClass: "mt-1" }, [
                              _c("span", { staticClass: "is-500" }, [
                                _vm._v("Comentario adicional:"),
                              ]),
                              _vm._v(
                                " " + _vm._s(cert.comentario) + "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        cert.estado !== "pendiente" &&
                        cert.estado !== "rechazado"
                          ? _c(
                              "span",
                              { staticClass: "is-size-6 is-400 mt-1" },
                              [
                                _c("span", { staticClass: "is-500" }, [
                                  _vm._v("Número de serie:"),
                                ]),
                                _vm._v(
                                  " " + _vm._s(cert.numero_serie) + "\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
            ])
          }),
      _vm._v(" "),
      _vm.certs.length === 0 && !_vm.isLoading
        ? _c("div", { staticClass: "box has-text-centered" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c("paginator", {
        ref: "paginator",
        attrs: { resource: _vm.url, loading: _vm.isLoading },
        on: {
          update: _vm.updateResource,
          "update:loading": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "section is-mono" }, [
      _c("span", { staticClass: "tag is-rounded is-medium" }, [
        _c("i", { staticClass: "fas fa-info fa-fw" }),
        _vm._v(" Sin certificados para mostrar\n      "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }